var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"question"},[_c('span',[_vm._v(_vm._s(_vm.n0)+" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.operation)}}),_vm._v(" "+_vm._s(_vm.n1)+" = ")]),_c('span',{class:_vm.rhsClass},[_vm._v(_vm._s(_vm.input))])])}
var staticRenderFns = []

export { render, staticRenderFns }